import { HTTP_INTERCEPTORS } from "@angular/common/http";
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from "@angular/core";
import { AuthorizationHttpInterceptor } from "app/authorization/AuthorizationHttpInterceptor";
import { IonicModule } from "ionic-angular";
import { CustomHttpInterceptor } from "providers/custom-http-interceptor/custom-http.interceptor";
import { AuthService } from "../../app/auth/auth.service";

@NgModule({
  imports: [IonicModule],

  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
  ],
})
export class StateManagementModule {
  constructor(@Optional() @SkipSelf() parentModule: StateManagementModule) {
    if (parentModule) {
      console.warn(
        "StateManagementModule is already loaded. Import it in the AppModule only."
      );
    }
  }
  static forRoot(featureServiceUrl: string): ModuleWithProviders {
    return {
      ngModule: StateManagementModule,
      providers: [
        { provide: "FeatureServiceUrl", useValue: featureServiceUrl },
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/providers/state-management/state-management.module.ts